"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "scafa": {
    "0628b7f9": [{
      "hkey": "69720364",
      "slug": "scafa",
      "name": "Scafa",
      "primary": true,
      "skipSearch": false
    }],
    "collemulino": [{
      "hkey": "69720364",
      "slug": "scafa",
      "name": "Scafa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8503d1ad": [{
      "hkey": "64274530",
      "slug": "mampioppo-colli",
      "name": "Mampioppo-Colli",
      "primary": true,
      "skipSearch": false
    }],
    "colli": [{
      "hkey": "64274530",
      "slug": "mampioppo-colli",
      "name": "Mampioppo-Colli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4f2d428b": [{
      "hkey": "64274530",
      "slug": "mampioppo-colli",
      "name": "Mampioppo-Colli",
      "primary": true,
      "skipSearch": false
    }],
    "mampioppo": [{
      "hkey": "64274530",
      "slug": "mampioppo-colli",
      "name": "Mampioppo-Colli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "scafa"
    }]
  }
};
exports["default"] = _default;